import GroupsDisplay from "./GroupsDisplay";
import { useToolkitGroupsStore } from "src/pods/groups/toolkitGroupsStore";
import { displayClose } from "src/pods/realtime";
import PresentationPage from "src/shared/components/PresentationPage";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

export default function GroupsDisplayContainer() {
  const { baseAvatarURL, groups } = useToolkitGroupsStore();
  const mutableGroups = groups?.map((group) => ({
    ...group,
    students: [...group.students],
  }));

  return (
    <PresentationPage variant="groups" onRequestHide={() => dispatchToolkitReduxAction(displayClose())}>
      <GroupsDisplay groups={mutableGroups} isReceiver={true} baseAvatarURL={baseAvatarURL} />
    </PresentationPage>
  );
}
